import controller from './shopping-experience.controller';
import templateBase from './templates/shopping-experience-base.view.html';
// import templateAD from './templates/confirmation-order-view-adaptative.html';

let ShoppingExperienceComponent = {
    template: templateBase,
    controller,
    bindings: {
        shCtrl: '<',
        order:'<'
    }
};


export default ShoppingExperienceComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shopping-experience/shopping-experience.component.js
 **/